<template>
  <div class="purchase-confirm-container position-relative">
    <div class="d-flex justify-content-start align-items-start mb-4" @click="close()">
      <div class="back-button d-flex align-items-center" :class="isPhone ? 'ml-2' : 'ml-5'">
        <img src="../../images/arrow-left-small.svg" alt="Back" />
      </div>
    </div>
    <div class="top-banner mt-5">
      <div class="w-100 d-flex flex-column justify-content-center align-items-center">
        <i class="fa-regular fa-circle-check"></i>
        <p class="text-green text-center" :class="isPhone ? 'merriweather-reg-24' : 'merriweather-reg-40'">Merci pour votre commande</p>
        <p class="text-center raleway-reg-p15">Votre commande a bien été enregistrée et est en cours de traitement. Un e-mail de confirmation vous a été envoyé à <span class="raleway-bold-p15">{{ giftBoxPurchase.owner.email }}</span> avec tous les détails de votre achat.</p>
      </div>
    </div>
    <div class="purchase-main-container w-100 h-100">
      <p class="raleway-semi-p18">DÉTAILS DE VOTRE COMMANDE</p>
      <div class="purchase-items-container">
        <div class="purchase-item" v-for="(item, index) in giftBoxPurchase.gift_box_purchase_items" :key="index">
          <div class="d-flex flex-row" style="gap: 25px;">
            <img :src="item.photo_key" alt="Gift Box Image">
            <div class="d-flex flex-column justify-content-between">
              <div>
                <p class="merriweather-reg-20">{{ item.name }}</p>
              </div>
              <div class="d-flex flex-column" style="gap: 5px;">
                <span class="raleway-medi-p15">Quantité : {{ item.quantity }}</span>
                <span class="raleway-medi-p15">Format : {{ item.format == 'physique' ? 'Physique' : 'E-Coffret' }}</span>
              </div>
              <span class="raleway-semi-p15 mt-2">Montant total : {{ item.total_amount }} €</span>
            </div>
          </div>
          <div class="border-bottom-gray" v-if="index != giftBoxPurchase.gift_box_purchase_items.length - 1"></div>
        </div>
        <div class="border-bottom-black  my-3"></div>
        <div class="d-flex flex-row justify-content-between mt-3 w-100">
          <span class="raleway-semi-p18">Montant total payé TTC</span>
          <span class="raleway-semi-p18">{{ purchaseTotal }} €</span>
        </div>
        <div class="info-container w-100" :class="isPhone ? 'mt-3' : 'mt-5'">
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-start">
              <img src="../../images/info.svg" v-set-alt/>
              <p class="raleway-semi-p15" :class="isPhone ? 'ml-2' : 'ml-3'">BESOIN D’AIDE ?</p>
            </div>
            <p class="mb-0 raleway-reg-p13">Notre service client est à votre disposition du <span class="raleway-semi-p13">lundi au vendredi, de 9h à 18h.</span> Vous pouvez nous contacter directement sur <span class="link-hortense">WhatsApp</span> ou <span class="link-hortense">nous écrire</span>.</p>
          </div>
        </div>
      </div>
    </div>
    <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-proposition-valeur-desktop-privilege.gif" alt="Club Hortense Banner" class="hortense-banner-img" style="width: 100%;" />
  </div>
</template>
<script>
export default {
  name: 'GiftBoxConfirmed',
  props: {
    giftBoxPurchase: {
      type: Object,
      required: true
    },
    purchaseTotal: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    isPhone() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  },
}
</script>
<style scoped>

.purchase-confirm-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .top-banner {
    min-height: 302px;
    max-height: fit-content;
    background-color: #A5D3AE21;
    padding: 40px 20% 40px 20%;

    @media screen and (max-width: 768px) {
      padding: 40px 10% 40px 10%;
    }

    i {
      font-size: 69px;
      color: #3B6152;
      margin-bottom: 20px;
    }
  }

  .text-green {
    color: #3B6152;
  }

  .purchase-main-container {
    padding: 50px 95px 50px 95px;

    @media screen and (max-width: 768px) {
      padding: 24px;
    }
  }

  .purchase-items-container {
    background-color: #F7F7F7A5;
    padding: 24px 72px 24px 72px;

    @media screen and (max-width: 768px) {
      padding: 16px 13px 16px 13px;
    }

    .purchase-item {
      margin-bottom: 10px;
      img {
        width: 166px;
        height: 160px;
        object-fit: cover;
      }

      @media screen and (max-width: 768px) {
        img {
          width: 113px;
          height: 148px;
        }
      }
    }
  }

  .border-bottom-gray {
    border-bottom: 0.5px solid #707070;
  }
  
  .border-bottom-black {
    border-bottom: 1px solid #000;
  }

  .info-container {
    padding: 25px;
    background-color: #A5D3AE48;
    min-height: 122px;
    max-height: fit-content;
    border-radius: 7px 7px 0px 7px;

    .link-hortense {
      color: #3B6152;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .back-button {
    width: 58px;
    height: 38px;
    border-radius: 5px;
    background: #00000029;

    img {
      width: 23px;
      margin-left: 8px;
    }
  }

}
@media screen and (max-width: 768px) {
  .back-button {
    width: 36px !important;
    height: 38px !important;

    img {
      margin-left: 0 !important;
      width: 20px !important;
    }
  }
}
</style>
